<script lang="ts" setup>
import { type List } from '~~/src/types/list'
import type { Elemental } from '~~/src/types/elemental'

type Items = (Elemental | List)[]

interface IProps {
  items?: Items
  isLoading?: boolean
  canLoadMore?: boolean
  showEmptyFeedMessage?: boolean
  adsPositions?: number[]

}

interface IEmits {
  (e: 'loadMore'): void
}

defineProps<IProps>()
defineEmits<IEmits>()
</script>

<script lang="ts">
export default defineComponent({
  name: 'Feed',
})
</script>

<template>
  <section v-if="items?.length" class=" flex flex-col w-full gap-2">
    <div v-for="(item, index) in items" :key="index">
      <template v-if="adsPositions?.includes(index)">
        <AppPubPrompt>
          <template #fallback>
            <ListCard v-if="item.isList" :list="item as List" :last-item="index === (items.length - 1)" variant="main-item" />
            <PromptCard
              v-else
              :prompt="item"
              :show-featured-tag="true"
              :show-upvote-button="true"
              :last-item="index === (items.length - 1)"
              variant="default"
            />
          </template>
        </AppPubPrompt>
      </template>
      <ListCard v-else-if="item.isList" :list="item as List" :last-item="index === (items.length - 1)" variant="main-item" />
      <PromptCard
        v-else
        :prompt="item"
        :show-featured-tag="true"
        :show-upvote-button="true"
        :last-item="index === (items.length - 1)"
        variant="default"
      />
    </div>
  </section>
  <Text v-else-if="showEmptyFeedMessage && !isLoading" variant="small" text-bluish-softer text-center my-4>
    No items found
  </Text>

  <AppLoading v-if="isLoading" />
  <Text
    v-else-if="canLoadMore"
    variant="small" text-center text-bluish-softer hover:text-bluish-darker cursor-pointer mt-5 mb-4
    @click.stop="!isLoading && $emit('loadMore')"
  >
    Load More
  </Text>
</template>
